<div class="loading-indicator">
    <mat-progress-spinner mode="indeterminate"  *ngIf="taskSearchDataSource.loading$ | async" bdColor="rgba(51,51,51,0.8)" diameter='25' strokeWidth='3'></mat-progress-spinner>
  </div>
  <section class="d-flex justify-content-end mar-r-10px">
    <!-- <button mat-flat-button color="primary" (click)="goBack()" title="Back">Back</button> -->
    <div class="d-flex align-items-center gap-2">
        <!-- <button (click)="isFilterApplied = !isFilterApplied" type="button" class="button-clss">
            <img src="../../../assets/filter.png" width="20px" alt="Filter">
        </button> -->
        <button joyrideStep = "taskNineStep" text="{{taskTourValues.taskNineStep}}" (click)="resetData()" type="button" mat-raised-button actions color="primary" class="button-container">CLEAR ALL</button>
    </div>
  </section>
<div class="table_mat_search" >
    <div class="grid-container">
        <table mat-table [dataSource]="taskSearchDataSource" matSort style="width: 100%;" (matSortChange)="sortData($event)">          
            <!-- meetingID Column -->
            <ng-container matColumnDef="taskTitle" >
              <th mat-header-cell *matHeaderCellDef>
                  <div >
                      <div mat-sort-header class="task_header">
                          Task Title
                      </div> 
                   <div class="filter_div" *ngIf="isFilterApplied">
                    <mat-form-field joyrideStep="taskFirstStep" text="{{taskTourValues.taskFirstStep}}" class="filter" floatLabel="always" style="width: 100px;">
                        <input matInput [formControl]="taskTitleFilter" [(ngModel)]="searchValue.taskTitle" (keyup)="filterValue(searchValue,$event)">
                        <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                        (click)="clearSearchField(displayedColumns[0],searchValue)" *ngIf="searchValue.taskTitle">
                        <mat-icon style="font-size: large;cursor: pointer;vertical-align: initial;">
                            close
                        </mat-icon>
                    </button>
                    </mat-form-field>
                   </div>
                  </div>
              </th>
              <td class="p-24 removeBorder" mat-cell *matCellDef="let element"><a id="TASK" class="f-weight a-size pointer margin-0" [routerLink]="[]" (click)="redirectToMeeting(element.meetingId,searchValue)" joyrideStep="taskEightStep" text="{{taskTourValues.taskEightStep}}"> <div [innerHTML]="element.taskTitle" class="word-break"></div></a></td>
            </ng-container>
        
            <!-- Date Column -->
            <ng-container matColumnDef="assignedBy">
              <th mat-header-cell *matHeaderCellDef>
                  <div >
                      <div mat-sort-header class="task_header">
                          Assigned By
                      </div>
                      <div class="filter_div" *ngIf="isFilterApplied" >
                        <mat-form-field joyrideStep="taskSecondStep" text="{{taskTourValues.taskSecondStep}}" class="filter" floatLabel="always" style="width: 100px;">
                            <input matInput  [formControl]="assignedByFilter" [(ngModel)]="searchValue.assignedBy" (keyup)="filterValue(searchValue,$event)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                            (click)="clearSearchField(displayedColumns[1],searchValue)" *ngIf="searchValue.assignedBy">
                            <mat-icon style="font-size: large;cursor: pointer;vertical-align: initial;">
                                close
                            </mat-icon>
                        </button>
                        </mat-form-field>
                    </div>
                    
                  </div>
              </th>
              <td  class="p-24 removeBorder"  mat-cell *matCellDef="let element"> {{element.assignedBy}} </td>
            </ng-container>
        
            <!-- Title Column -->
            <ng-container matColumnDef="assignedTo">
              <th mat-header-cell *matHeaderCellDef>
                  <div >
                      <div mat-sort-header class="task_header">
                          Assigned To
                      </div>
                      <div class="filter_div" *ngIf="isFilterApplied" >
                        <mat-form-field class="filter" joyrideStep="taskThirdStep" text="{{taskTourValues.taskThirdStep}}" floatLabel="always" style="width: 200px;">
                            <input matInput [formControl]="assignedToFilter" [(ngModel)]="searchValue.assignedTo" (keyup)="filterValue(searchValue,$event)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                            (click)="clearSearchField(displayedColumns[2],searchValue)" *ngIf="searchValue.assignedTo">
                            <mat-icon style="font-size: large;cursor: pointer;vertical-align: initial;">
                                close
                            </mat-icon>
                        </button>
                        </mat-form-field>
                    </div>
                     
                  </div>
              </th>
              <td class="removeBorder" mat-cell *matCellDef="let element"> {{element.ownerNames}} </td>
            </ng-container>
        
            <!-- Agenda Column -->
            <ng-container matColumnDef="dueDate">
              <th mat-header-cell *matHeaderCellDef>
                  <div >
                      <div mat-sort-header class="task_header">
                          Due/Completion Date
                      </div>
                      <div class="filter_div" *ngIf="isFilterApplied" >
                        <!--<mat-form-field class="filter" floatLabel="never" style="width: 230px;">
                            <input matInput [formControl]="dueDateFilter" placeholder="Due/Completion Date">
                        
                        </mat-form-field>-->
                      <mat-form-field joyrideStep="taskFiveStep" text="{{taskTourValues.taskFiveStep}}" class="filter" floatLabel="always" style="width: 230px;">
                            <input #input matInput [formControl]="dueDateFilter" [(ngModel)]="searchValue.dueDate" [matDatepicker]="picker" (focus)="picker.open()" (dateInput)="applyfilter(searchValue)" [readonly]="true">
                            <mat-datepicker #picker></mat-datepicker>
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                            (click)="clearSearchField(displayedColumns[3],searchValue)" *ngIf="searchValue.dueDate">
                            <mat-icon style="font-size: large;cursor: pointer;vertical-align: initial;">
                                close
                            </mat-icon>
                        </button>
                        </mat-form-field>
                    </div>
                  
                  </div>
              </th>
              <td class="removeBorder" mat-cell *matCellDef="let element"> {{element.dueOrCompDate}} </td>
            </ng-container>
      
            <!-- Facilitator Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>
                  <div>
                      <div mat-sort-header class="task_header">
                          Task Status
                      </div>
                      <div class="filter_div" *ngIf="isFilterApplied" >
                        <mat-form-field joyrideStep="taskSixStep" text="{{taskTourValues.taskSixStep}}" class="filter" floatLabel="always" style="width: 100px;">
                            <input matInput [formControl]="statusFilter" [(ngModel)]="searchValue.status" (keyup)="filterValue(searchValue,$event)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                            (click)="clearSearchField(displayedColumns[4],searchValue)" *ngIf="searchValue.status">
                            <mat-icon style="font-size: large;cursor: pointer;vertical-align: initial;">
                                close
                            </mat-icon>
                        </button>
                        </mat-form-field>
                    </div>
                     
                  </div>
              </th>
              <td class="removeBorder" mat-cell *matCellDef="let element"> {{element.taskStatus}} </td>
            </ng-container>
      
            <!-- Participants Column -->
            <ng-container matColumnDef="meetingTitle">
              <th mat-header-cell *matHeaderCellDef>
                  <div >
                      <div mat-sort-header class="task_header">
                          Meeting Title
                      </div>
                      <div class="filter_div" *ngIf="isFilterApplied">
                        <mat-form-field class="filter" joyrideStep="taskSevenStep" text="{{taskTourValues.taskSevenStep}}" floatLabel="always" style="width: 110px;">
                            <input matInput [formControl]="meetingTitleFilter"  [(ngModel)]="searchValue.meetingTitle" (keyup)="filterValue(searchValue,$event)">
                            <button mat-button matSuffix mat-icon-button aria-label="Clear" class="close-icon-bttn"
                            (click)="clearSearchField(displayedColumns[5],searchValue)" *ngIf="searchValue.meetingTitle">
                            <mat-icon style="font-size: large;cursor: pointer;vertical-align: initial;">
                                close
                            </mat-icon>
                        </button>
                        </mat-form-field>
                    </div>
                    
                  </div>
              </th>
              <td class="removeBorder" mat-cell *matCellDef="let element"> {{element.meetingTaskTitle}} </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell removeBorder" colspan="4" *ngIf="this.taskSearchDataSource.totalCount=== 0">No data matching the filter</td>
              </tr>
          </table>
    </div>
    <div class="table-footer">    
        <mat-paginator joyrideStep="taskTenStep" text="{{taskTourValues.taskTenStep}}" [pageSizeOptions]="[25,50,75,100]" [pageSize]="25"
            showFirstLastButtons 
            aria-label="Select page of periodic elements">
        </mat-paginator>
        
    </div>
</div>
